import { SEMANTIC_ROLE_OPTIONS, labelForSemanticRole } from './behaviourCatalog';

export const REQUIRED_PUBLISH_ROLES = [
  'GROSS_UPTO_DATE',
  'CURRENT_RA_VALUE',
  'TOTAL_RECOVERIES',
  'TOTAL_WITHHELD',
  'NET_PAYABLE',
];

const ROLE_HINTS = {
  GROSS_UPTO_DATE: [/gross\s*upto/i, /^gross\s*amount$/i, /upto\s*date\s*gross/i, /gross\s*value/i],
  CURRENT_RA_VALUE: [/current\s*ra/i, /^total\s*amount$/i, /net\s*value.*previous/i, /this\s*bill/i],
  TOTAL_RECOVERIES: [/total\s*recover/i, /total\s*deduction/i],
  TOTAL_WITHHELD: [/total\s*withheld/i, /^hold\s*amount/i, /withheld/i],
  NET_PAYABLE: [/net\s*payable/i, /net\s*payment/i, /net\s*certified/i],
  TOTAL_DEDUCTIONS: [/total\s*deduction/i],
  SECURITY_DEPOSIT: [/security\s*deposit/i, /\bsd\b/i],
  GST_DEDUCTION: [/gst\s*tds/i, /gst\s*deduction/i],
  INCOME_TAX: [/income\s*tax/i],
  LABOUR_CESS: [/labour\s*cess/i, /labor\s*cess/i],
};

/**
 * Suggest fieldCode assignments for missing required semantic roles.
 * @returns {{ role: string, roleLabel: string, fieldCode: string, fieldLabel: string }[]}
 */
export const suggestRequiredRoleAssignments = (fields = []) => {
  const active = (fields || []).filter((f) => String(f.status || 'ACTIVE').toUpperCase() === 'ACTIVE');
  const taken = new Set(active.map((f) => f.semanticRole).filter(Boolean));
  const usedFields = new Set();
  const suggestions = [];

  REQUIRED_PUBLISH_ROLES.forEach((role) => {
    if (taken.has(role)) return;
    const hints = ROLE_HINTS[role] || [];
    const match = active.find((f) => {
      if (usedFields.has(f.fieldCode)) return false;
      if (f.semanticRole) return false;
      const text = `${f.fieldCode} ${f.fieldLabel || ''}`;
      return hints.some((re) => re.test(text));
    });
    if (match) {
      usedFields.add(match.fieldCode);
      suggestions.push({
        role,
        roleLabel: labelForSemanticRole(role),
        fieldCode: match.fieldCode,
        fieldLabel: match.fieldLabel || match.fieldCode,
      });
    }
  });

  return suggestions;
};

export const missingRequiredRoles = (fields = []) => {
  const taken = new Set(
    (fields || [])
      .filter((f) => String(f.status || 'ACTIVE').toUpperCase() === 'ACTIVE' && f.semanticRole)
      .map((f) => f.semanticRole),
  );
  return REQUIRED_PUBLISH_ROLES.filter((r) => !taken.has(r)).map((role) => ({
    role,
    roleLabel: labelForSemanticRole(role),
  }));
};

export { SEMANTIC_ROLE_OPTIONS };
